import React, { Component } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { connect } from 'react-redux'
import { sidebarExpand, socketManager } from '../../actions'
import HomeIcon from '@mui/icons-material/Home';
import io from 'socket.io-client'
import { Link } from 'react-router-dom'
import {
    isPushNotificationSupported,
    initializePushNotifications,
} from "./../../push-notifications.js";

const socketUrl = "https://silver-house.ir";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            socket: null
        }
    }
    componentDidMount() {
        this.initSocket();
        this.setState({ socket: socketManager() })

    }
    initSocket = () => {
        const socket = io(socketUrl);
        socket.on('connect'
            , () => {
                this.setState({ socket });
                this.getNotifications();
            })
        this.props.dispatch(socketManager(socket));
    }
    getNotificationPermissionState = async () => {
        if (navigator.permissions) {
            let result = await navigator.permissions.query({ name: 'notifications' })
            return result.state;
        }
    }
    getNotifications = async () => {
        const { socket } = this.state;
        socket.on('notification', async data => {
            console.log(data);
            let currentPermissionState = this.getNotificationPermissionState()
            if (currentPermissionState !== 'granted') {
                let result = await Notification.requestPermission()
                if (result !== 'granted') {
                    return;
                } else {
                    const pushNotificationSuported = isPushNotificationSupported();
                    if (pushNotificationSuported) {
                        initializePushNotifications().then(function (consent) {
                            if (consent === 'granted') {
                                const img = data.image;
                                const text = data.text;
                                const title = data.title;
                                const options = {
                                    body: text,
                                    icon: "https://silver-house.ir/static/icons/homescreen48.png",
                                    vibrate: [200, 100, 200, 400],
                                    tag: "new-product",
                                    image: img,
                                    actions: [{ action: "Detail", title: "نمایش", icon: "https://silver-house.ir/static/icons/homescreen48.png" }]
                                };
                                navigator.serviceWorker.ready.then(function (registration) {
                                    registration.showNotification(title, options);
                                });
                            }
                        });
                    }
                }
            }

        })
    }
    expandeMenu = () => {
        this.setState({ expanded: !this.props.expandMode }, () => {
            this.props.dispatch(sidebarExpand(!this.props.expandMode));
        })

    };
    render() {
        const { title, expandMode, isHome } = this.props;
        return (
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" className="titleBar-txt">
                        {title}
                    </Typography>
                    <Link to="/" className={`back-item ${isHome ? "none" : ""}`}>
                        <IconButton edge="start"color="inherit">
                            <HomeIcon />
                        </IconButton>
                    </Link>
                    <IconButton edge="start" onClick={this.expandeMenu} color="inherit" className={`settings-btn ${isHome ? "alone" : ""}`} aria-label="menu">
                        {expandMode ? <CloseIcon /> : <MenuIcon />}

                    </IconButton>

                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = state => {
    return {
        expandMode: state.expandMode,
        title: state.setTitle,
        socket: state.setSocket,
        isHome: state.detectHome,
    }
}
export default connect(mapStateToProps)(Header);